import React from 'react';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { stopPropagationAndPreventDefault } from 'components/searchAndFilter/utils';
import { ButtonsListContainer } from 'components/Button';

interface Props {
  title: string;
  onClick: (e) => void;
  panelSideButtons: RMCustomButtonProps[];
  panelLeftButtons: RMCustomButtonProps[];
  containerClass?: string;
}

const SectionHeader = (props: Props) => {
  const {
    title,
    onClick,
    panelSideButtons,
    panelLeftButtons,
    containerClass = '',
  } = props;

  return (
    <div
      id={`containers-sectionheader-wrapper`} 
      className={`flex flex-row justify-between items-center min-w-[382px] h-10 p-2 gap-2 bg-[#fafafa] border border-gray-300 border-solid cursor-pointer ${containerClass}`}
      onClick={onClick}
    >
      <div id={`containers-sectionheader-${title}`}  className="font-roboto font-medium text-[14px] leading-[19.6px] text-[#313131]">
        {title}
      </div>
      <div
        id={`containers-sectionheader-actions`} 
        className="collapsable-header-icons flex flex-row gap-[8px]"
        onClick={stopPropagationAndPreventDefault}
      >
        {panelLeftButtons?.length > 0 && (
          <div
             id={`containers-sectionheader-leftbutton`} 
            className={'flex flex-row '}>
            <ButtonsListContainer buttonsList={panelLeftButtons} />
          </div>
        )}
        {panelSideButtons?.length > 0 && (
          <ButtonsListContainer buttonsList={panelSideButtons} />
        )}
      </div>
    </div>
  );
};

export default SectionHeader;
